import { useState } from 'react'
import Label from '../../../ui/Label';
import DropdownBtn from '../../../ui/DropdownBtn';
import { updateNewProduct } from '../../../../features/product/productSlice';
import { useDispatch } from 'react-redux';

interface ProdModAvailableProps {
    setSelectedAvailableOption: (value: boolean) => void;
    selectedAvailableOption: boolean;
}

export default function ProdModAvailable({ setSelectedAvailableOption, selectedAvailableOption }: ProdModAvailableProps) {

    const dispatch = useDispatch()
    const [isOpenDropdownStatus, setIsOpenDropdownStatus] = useState<boolean>(false)
    const AvailableOptions = ["Yes", "No" ]
    const labelStatus = selectedAvailableOption ? "Yes" : "No";

    return (
        <div className=''>
            <Label label={'Available *'} />
            <div className='relative inline-block h-auto w-full'>
                <div className='w-full h-auto'>
                    <DropdownBtn
                        label={labelStatus}
                        isOpen={isOpenDropdownStatus}
                        setIsOpenStatus={setIsOpenDropdownStatus}
                        isCustomClass={true}
                        customClass={'flex w-full justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                    />
                    {isOpenDropdownStatus && (
                        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                            {AvailableOptions.map((opt, i) => (
                                <li
                                    key={i}
                                    onClick={() => {
                                        const isAvailable = opt === "Yes";
                                        setIsOpenDropdownStatus(false)
                                        setSelectedAvailableOption(isAvailable)
                                        dispatch(updateNewProduct({ isAvailable: isAvailable }))
                                    }}
                                    className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                                >
                                    {opt}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    )
}
